import { call } from 'redux-saga/effects';
import * as Api from '../../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../../helpers/saga';
import {
  fetchInventoryItemTagsOptions as fetchInventoryItemTagsOptionsRoutine,
  fetchInventoryPackageTagsOptions as fetchInventoryPackageTagsOptionsRoutine,
  fetchInventoryItemAvailabilityLocationZoneOptions as fetchInventoryItemAvailabilityLocationZoneOptionsRoutine,
  fetchInventoryPackageAvailabilityLocationOptions as fetchInventoryPackageAvailabilityLocationOptionsRoutine,
  fetchTrackingMethodOptions as fetchTrackingMethodOptionsRoutine
} from './routines';

export const fetchInventoryItemTagsOptions = () =>
  sagaRoutineRequest(fetchInventoryItemTagsOptionsRoutine, {
    request: () => call(Api.fetchInventoryItemTagsOptions)
  });

export const fetchInventoryPackageTagsOptions = () =>
  sagaRoutineRequest(fetchInventoryPackageTagsOptionsRoutine, {
    request: () => call(Api.fetchInventoryPackageTagsOptions)
  });

export const fetchInventoryItemAvailabilityLocationZoneOptions = () =>
  sagaRoutineRequest(fetchInventoryItemAvailabilityLocationZoneOptionsRoutine, {
    request: () => call(Api.fetchInventoryItemAvailabilityLocationZoneOptions)
  });

export const fetchInventoryPackageAvailabilityLocationOptions = () =>
  sagaRoutineRequest(fetchInventoryPackageAvailabilityLocationOptionsRoutine, {
    request: () => call(Api.fetchInventoryPackageAvailabilityLocationOptions)
  });

export const fetchTrackingMethodOptions = () =>
  sagaRoutineRequest(fetchTrackingMethodOptionsRoutine, {
    request: () => call(Api.fetchTrackingMethodOptions)
  });
